import { withPriceSeperator } from '@flight-workspace/common-client/src/util/number';
import classNames from 'classnames/bind';
import { MouseEventHandler } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  themeId: number;
  isSelected: boolean;
  themeName: string;
  themeImage: string;
  minFare: number;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export default function ThemeCard({
  themeId,
  isSelected,
  themeName,
  themeImage,
  minFare,
  onClick,
}: IProps) {
  return (
    <button
      type="button"
      className={cx('ThemeCard')}
      aria-selected={isSelected}
      onClick={onClick}
      data-event-nlog="click"
      data-event-area-code={`rft.theme${themeId ? themeId : ''}`}
    >
      <div className={cx('thumb')}>
        <img src={themeImage} alt="" />
      </div>
      <b className={cx('name')}>{themeName}</b>
      {minFare > 0 && (
        <span className={cx('sub')}>
          <i className={cx('price')}>{withPriceSeperator(minFare)}</i>
          원~
        </span>
      )}
    </button>
  );
}
